import styled from 'styled-components';

export const Text = styled.span`
  display: flex;
  color: ${({ theme }) => theme.tokens.colors.system[100]};
  font-size: 0.7rem;
  line-height: 0.75rem;
  margin-top: 0.25rem;
  min-height: 1.1rem;

  &:empty {
    display: none;
  }
`;
